import React, { useRef } from "react";
import { RangeSlider } from "Components/atoms/RangeSlider";
// import RangeSlider from "react-range-slider-input";
import { Typography } from "Components/atoms/Typography";
import { RangeFilterWrapper, TitleWrapper } from "./styles";
import { RangeFilterProps } from "./types";
import { FilterElement } from "../FilterElement";
import { formatCurrency } from "shared/utils/prices";
import "react-range-slider-input/dist/style.css";
import "./RangeSliderStyles.css";

/**
 * Converte um número de minutos para o formato HH:MM
 * @param {number} minutes - Número de minutos a serem convertidos
 * @returns {string} - Retorna a string formatada como "HH:MM"
 */
const formatTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
};

/**
 * Componente RangeFilter
 *
 * Permite selecionar um intervalo de valores utilizando um controle deslizante.
 *
 * @param {string} title - Título do filtro.
 * @param {string} iconName - Ícone do filtro.
 * @param {number} minValue - Valor mínimo do intervalo.
 * @param {number} maxValue - Valor máximo do intervalo.
 * @param {[number, number]} valueRange - Intervalo atual selecionado.
 * @param {(value: [number, number]) => void} handleValueChange - Callback para atualizar o intervalo selecionado.
 * @param {string} type - Tipo do filtro ("currency", "time" ou "default").
 */
export const RangeFilter: React.FC<RangeFilterProps> = ({
  title,
  iconName,
  minValue,
  maxValue,
  valueRange,
  handleValueChange,
  value,
  type,
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  let previousScrollY = 0;

  const lockScroll = () => {
    previousScrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${previousScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";
  };

  const unlockScroll = () => {
    document.body.style.overflow = "auto";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";
    window.scrollTo(0, previousScrollY);
  };

  const handleTouchStart = () => lockScroll();
  const handleTouchEnd = () => unlockScroll();

  return (
    <RangeFilterWrapper>
      <FilterElement title={title} iconName={iconName}>
        <TitleWrapper>
          <Typography color="black">
            {type === "time" && "Entre "}
            <strong>
              {type === "currency"
                ? `R$ ${formatCurrency(value[0]).first},${formatCurrency(value[0]).second}`
                : type === "time"
                  ? formatTime(value[0])
                  : value[0]}
            </strong>
            &nbsp;e&nbsp;
            <strong>
              {type === "currency"
                ? `R$ ${formatCurrency(value[1]).first},${formatCurrency(value[1]).second}`
                : type === "time"
                  ? formatTime(value[1])
                  : value[1]}
            </strong>
          </Typography>
        </TitleWrapper>

        <div
          ref={sliderRef}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <RangeSlider
            className="slider-filter"
            min={minValue}
            max={maxValue}
            step={type === "currency" ? 1 : 30}
            value={valueRange}
            // defaultValue={valueRange}
            onInput={handleValueChange}
          />
        </div>
      </FilterElement>
    </RangeFilterWrapper>
  );
};
